/**
 * Wrap console.error so we can pass it directly to a promise's `.catch()` function
 * without allocating memory for yet another closure
 **/
export function logError(error: any) {
  console.error(error);
}
